// Referral contest API — kept beside Contact Saver so client.js doesn't need changing.
import axios from 'axios';

const API = axios.create({ baseURL: process.env.REACT_APP_API_URL || '/api', withCredentials: true });
API.interceptors.request.use(cfg => {
  const token = localStorage.getItem('sAuthToken');
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

export const getContests     = (id) => API.get('/contact-saver/contest.php', { params: { view: 'overview', ...(id ? { id } : {}) } });
export const searchContest   = (id, q) => API.get('/contact-saver/contest.php', { params: { view: 'board', id, q } });
export const exportContest   = (id) => API.get('/contact-saver/contest.php', { params: { view: 'export', id }, responseType: 'blob' });
export const contestAction   = (action, extra = {}) => API.post('/contact-saver/contest.php', { action, ...extra });

// public pages (no login) — plain fetch, no auth header
const PUBLIC = `${process.env.REACT_APP_API_URL || '/api'}/contest/public.php`;
/** Read the answer; if the server sent something that isn't JSON (missing file, PHP error), say so plainly. */
const read = async r => {
  const text = await r.text();
  try { return JSON.parse(text); }
  catch {
    console.error('[contest] not JSON from', r.url, r.status, text.slice(0, 300));
    return { success: false, message: r.status === 404
      ? 'The contest service wasn’t found on the server (api/contest/public.php is missing).'
      : `The contest service had a problem (HTTP ${r.status}). Please try again shortly.` };
  }
};
export const getPublicContest = (slug, phone) => fetch(`${PUBLIC}?slug=${encodeURIComponent(slug)}${phone ? `&phone=${encodeURIComponent(phone)}` : ''}`).then(read);
export const joinContest      = (slug, name, phone) => fetch(PUBLIC, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ slug, name, phone }) }).then(read);
export const resolveInvite    = (code) => fetch(`${PUBLIC}?code=${encodeURIComponent(code)}`).then(read);